module.exports = "/assets/e61d7e7fb43689bb41ff11898e428be4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/JC.png
// module id = 1505
// module chunks = 0